var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClipboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1H9V.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5V1H1.5a1.001 1.001 0 00-1 1v10.5a1.001 1.001 0 001 1h9a1.002 1.002 0 001-1V2a1.001 1.001 0 00-1-1zM4 1h4v1.5H4V1z",
    fill: "#A3A3A9"
  })));
}

export default SvgClipboard;